"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var handlebars_1 = require("handlebars");

var attributes_1 = require("./templates/attributes");

var body_1 = require("./templates/body");

var classes_1 = require("./templates/classes");

var general_information_1 = require("./templates/general_information");

var head_content_1 = require("./templates/head_content");

var head_1 = require("./templates/head");

var layout_1 = require("./templates/layout");

var relations_1 = require("./templates/relations");

var styles_1 = require("./templates/styles");

var terms_index_1 = require("./templates/terms_index");

handlebars_1["default"].registerHelper('compare', function (v1, operator, v2, options) {
  'use strict';

  var operators = {
    '==': v1 == v2 ? true : false,
    '===': v1 === v2 ? true : false,
    '!=': v1 != v2 ? true : false,
    '!==': v1 !== v2 ? true : false,
    '>': v1 > v2 ? true : false,
    '>=': v1 >= v2 ? true : false,
    '<': v1 < v2 ? true : false,
    '<=': v1 <= v2 ? true : false,
    '||': v1 || v2 ? true : false,
    '&&': v1 && v2 ? true : false
  };

  if (operators.hasOwnProperty(operator)) {
    if (operators[operator]) {
      return options.fn(this);
    }

    return options.inverse(this);
  }

  return console.error("Error: Expression \"" + operator + "\" not found");
});

function getHBSTemplate(options) {
  var documentationProps = options.documentationProps;
  var customPartials = (documentationProps || {}).customPartials;

  var _a = customPartials || {},
      _b = _a.headContent,
      headContent = _b === void 0 ? head_content_1["default"] : _b,
      _c = _a.styles,
      styles = _c === void 0 ? styles_1["default"] : _c,
      _d = _a.head,
      head = _d === void 0 ? head_1["default"] : _d,
      _e = _a.body,
      body = _e === void 0 ? body_1["default"] : _e,
      _f = _a.generalInformation,
      generalInformation = _f === void 0 ? general_information_1["default"] : _f,
      _g = _a.termsIndex,
      termsIndex = _g === void 0 ? terms_index_1["default"] : _g,
      _h = _a.classes,
      classes = _h === void 0 ? classes_1["default"] : _h,
      _j = _a.relations,
      relations = _j === void 0 ? relations_1["default"] : _j,
      _k = _a.attributes,
      attributes = _k === void 0 ? attributes_1["default"] : _k;

  var partials = [{
    name: 'head_content',
    partial: headContent
  }, {
    name: 'styles',
    partial: styles
  }, {
    name: 'head',
    partial: head
  }, {
    name: 'body',
    partial: body
  }, {
    name: 'general_information',
    partial: generalInformation
  }, {
    name: 'terms_index',
    partial: termsIndex
  }, {
    name: 'classes',
    partial: classes
  }, {
    name: 'relations',
    partial: relations
  }, {
    name: 'attributes',
    partial: attributes
  }];
  partials.forEach(function (_a) {
    var name = _a.name,
        partial = _a.partial;
    handlebars_1["default"].registerPartial(name, partial);
  });
  return handlebars_1["default"].compile(layout_1["default"]);
}

exports.getHBSTemplate = getHBSTemplate;